import styled, { css } from 'styled-components'
import styledTheme from '../../../styles/theme'

export const SettingsButton = styled.div`
  height: 32px;
  width: 32px;
  border: 2px solid ${styledTheme.colors.action_link};
  border-radius: 6px;
  background-color: white;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  svg {
    height: 22px;
    width: 23px;
    g g {
      fill: ${styledTheme.colors.action_link};
    }
  }
`
export const GraphMenuContainerDiv = styled.div`
  border: 2px solid ${styledTheme.colors.action_link};
  border-radius: 4px;
  background-color: white;
  padding: 0px 4px;
  display: 'flex';
  flexDirection: 'column';
  flex: 1;
  zIndex: 22;
  -webkit-box-shadow: 3px 3px 5px 0px rgba(71,71,71,0.96);
  box-shadow: 3px 3px 5px 0px rgba(71,71,71,0.96);
`
export const GraphMenuItemDiv = styled.div`
  padding: 8px;
  border-width: 0px;
  border-bottom: 1px solid ${styledTheme.colors.action_link};
  cursor: pointer;
  &:last-of-type {
    border-bottom: 0px;
  }
`
export const GraphMenuScreenOverlay = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  bottom: 0px;
  left: 0px;
  right: 0px;
  top: 0px;
  z-index: 25;
`



// WEBPACK FOOTER //
// ./src/components/dataViews/controls/styled-elements.js